// Own streams for one mounted workspace. Clones share a source but can stop independently.
export function createAudioCaptureOwner() {
  const streams = new Set();
  let closed = false;
  const release = stream => {
    if (!stream) return;
    streams.delete(stream);
    stream.getTracks().forEach(track => track.stop());
  };
  const own = stream => {
    if (closed) {
      release(stream);
      throw new Error('Audio capture was cancelled');
    }
    streams.add(stream);
    return stream;
  };
  return {
    acquire: async constraints => own(await navigator.mediaDevices.getUserMedia(constraints)),
    own,
    clone: stream => own(stream.clone()),
    release,
    dispose: () => {
      closed = true;
      [...streams].forEach(release);
    },
  };
}
